export default "__VITE_ASSET__c7997f91__"